const FUSEAU_EPISODES = 'America/Toronto';
const LIBELLE_FUSEAU_EPISODES = 'Toronto';

const formateurParties = new Intl.DateTimeFormat('fr-CA', {
  timeZone: FUSEAU_EPISODES,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

const timestampValide = (valeur) => {
  if (valeur === null || valeur === undefined || valeur === '' || valeur === 0) return null;
  const date = new Date(valeur);
  return Number.isNaN(date.getTime()) ? null : date;
};

const extraireParties = (date) => {
  const parties = formateurParties.formatToParts(date).reduce((resultat, partie) => ({
    ...resultat,
    [partie.type]: partie.value,
  }), {});

  return {
    date: `${parties.year}-${parties.month}-${parties.day}`,
    heure: `${parties.hour}:${parties.minute}`,
  };
};

const extraireHeureBrute = (valeur) => {
  const correspondance = String(valeur || '').match(/(?:^|[T\s])([01]\d|2[0-3]):([0-5]\d)(?::[0-5]\d(?:\.\d+)?)?(?:Z|[+-]\d{2}:?\d{2})?$/);
  return correspondance ? `${correspondance[1]}:${correspondance[2]}` : '--:--';
};

const arrondirDureeMinutes = (dureeMs) => {
  if (dureeMs < 60 * 1000) return '< 1 min';
  return `${Math.round(dureeMs / (60 * 1000))} min`;
};

export const decrireTemporaliteEpisode = (episode = {}) => {
  const evenements = episode.evenements || [];
  const debutBrut = episode.debutBrut || (evenements[0] && evenements[0].timestamp);
  const finBrut = episode.finBrut || (evenements[evenements.length - 1] && evenements[evenements.length - 1].timestamp);
  const dateDebut = timestampValide(episode.debut);
  const dateFin = timestampValide(episode.fin);
  const debut = dateDebut ? extraireParties(dateDebut) : {
    date: null,
    heure: extraireHeureBrute(debutBrut),
  };
  const fin = dateFin ? extraireParties(dateFin) : {
    date: null,
    heure: extraireHeureBrute(finBrut),
  };
  const debutConnu = Boolean(dateDebut);
  const finRenseignee = (episode.fin !== null && episode.fin !== undefined && episode.fin !== '')
    || Boolean(finBrut);
  const finConnue = Boolean(dateFin);
  const chronologieInvalide = debutConnu && finConnue && dateFin.getTime() < dateDebut.getTime();
  const traverseMinuit = debutConnu
    && finConnue
    && !chronologieInvalide
    && debut.date !== fin.date;

  let lignesTitre;
  if (debutConnu && finConnue && traverseMinuit) {
    lignesTitre = [`${debut.date} ${debut.heure}`, `→ ${fin.date} ${fin.heure}`];
  } else if (debutConnu && finConnue) {
    const prefixeFin = debut.date === fin.date ? fin.heure : `${fin.date} ${fin.heure}`;
    lignesTitre = [`${debut.date} ${debut.heure} → ${prefixeFin}`];
  } else if (debutConnu) {
    lignesTitre = [`${debut.date} ${debut.heure} → Fin inconnue`];
  } else {
    lignesTitre = [`Date inconnue • ${debut.heure} → ${finRenseignee ? fin.heure : 'Fin inconnue'}`];
  }

  const indicateurs = [];
  if (chronologieInvalide) {
    indicateurs.push('Durée : invalide', 'Fin antérieure au début');
  } else if (debutConnu && finConnue) {
    indicateurs.push(`Durée : ${arrondirDureeMinutes(dateFin.getTime() - dateDebut.getTime())}`);
  } else {
    indicateurs.push('Durée : inconnue');
    if (debutConnu && !finConnue) indicateurs.push('Fin inconnue');
  }
  if (traverseMinuit) indicateurs.push('Traverse minuit');
  indicateurs.push(`TZ : ${LIBELLE_FUSEAU_EPISODES}`);

  return {
    lignesTitre,
    indicateur: indicateurs.join(' • '),
    chronologieInvalide,
    traverseMinuit,
  };
};

export {
  FUSEAU_EPISODES,
  LIBELLE_FUSEAU_EPISODES,
};



// WEBPACK FOOTER //
// src/components/cockpit/episodeTemporalite.js